import React from 'react';
import { Button, Modal } from 'antd';
import ModalAddCustomer from './ModalAddCustomer';
import { deleteData } from '../../helper/api';
import { toast } from 'react-toastify';

function ActionCustomer(props) {
    const { record, trigerFetchData, setTrigerFetchData } = props;
    const [openModalAdd, setOpenModalAdd] = React.useState(false);
    const [openModalDelete, setOpenModalDelete] = React.useState(false);

    const handleDeleteCustomer = () => {
        deleteData(`/customers/${record.id}`)
            .then((response) => {
                if (response.status === 200) {
                    toast.success('Customer deleted successfully');
                    setTrigerFetchData(!trigerFetchData);
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <div style={{ display: "flex", gap: "20px" }}>
             <Modal
                title="Delete"
                open={openModalDelete}
                onOk={() => handleDeleteCustomer()}
                onCancel={() => setOpenModalDelete(false)}
            >
                {/* ARE YOU SURE */}
                <h2>Are you sure want to delete this customer {record.id}?</h2>
            </Modal>
            <ModalAddCustomer open={openModalAdd} setOpen={setOpenModalAdd} initialData={record} trigerFetchData={trigerFetchData} setTrigerFetchData={setTrigerFetchData} />
            <Button className="items-center flex justify-center text-white bg-blue-400" onClick={() => setOpenModalAdd(true)}>
                Edit
            </Button>
            {/* <Button className="items-center flex justify-center text-white bg-blue-400" danger className="item-center" onClick={() => setOpenModalDelete(true)}>
                Delete
            </Button> */}
        </div>
    );
}

export default ActionCustomer;